import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [categories, setCategories] = useState([]);
  const [zones, setZones] = useState([]);

  const reload = async () => {
    const [s, c, z] = await Promise.all([api.get("/settings/public"), api.get("/categories"), api.get("/shipping/zones")]);
    setSettings(s.data);
    setCategories(c.data);
    setZones(z.data);
  };

  useEffect(() => {
    reload().catch(() => setSettings({}));
  }, []);

  return <StoreContext.Provider value={{ settings, categories, zones, reload }}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
